/**
 * Which profile rail to show: orders-only vs account/dashboard.
 * Uses the first path segment after `user_profile` (stable vs substring traps like open_orders vs futures_open_orders).
 */

/** Segments under /user_profile/* that use the orders sidebar. */
export const ORDER_SIDEBAR_SEGMENTS = new Set([
  "spot_orders",
  "spot_order_history",
  "spot_position_history",
  "spot_open_orders",
  "open_orders",
  "futures_open_orders",
  "futures_order_history",
  "position_orders",
  "position_history",
  "futures_trade_history",
  "options_open_orders",
  "options_order_history",
  "options_trade_history",
  "options_position_history",
  "transaction_history",
  "swap_history",
  "wallet_transfer_History",
  "earning_plan_history",
  "staking_orders",
  "launchpad_orders",
  "convert_orders",
  "otc_trade",
  "otc_orders",
  "otc_order_history",
  "copy_trading_orders",
  "bonus_history",
  "launchpad_transactions",
  "orders",
]);

export function getUserProfileSegment(pathname) {
  const parts = pathname.split("/").filter(Boolean);
  const idx = parts.indexOf("user_profile");
  if (idx < 0) return "";
  return parts[idx + 1] || "";
}

/** When using /user_profile/orders/<segment>, return the nested segment. */
export function getUserProfileOrdersSegment(pathname) {
  const parts = pathname.split("/").filter(Boolean);
  const idx = parts.indexOf("user_profile");
  if (idx < 0) return "";
  if (parts[idx + 1] !== "orders") return "";
  return parts[idx + 2] || "";
}

export function isWalletSidebarPath(pathname) {
  return (
    pathname.includes("/user_profile/asset_overview")
    || pathname.includes("/user_profile/wallet/")
    || pathname.includes("/user_profile/cross_margin")
    || pathname.includes("/user_profile/staking")
  );
}

export function isOrderSidebarPath(pathname) {
  const seg = getUserProfileSegment(pathname);
  if (!seg) return false;
  if (ORDER_SIDEBAR_SEGMENTS.has(seg)) return true;
  if (seg === "swap") return true;
  return false;
}
